import React, { Component, PureComponent } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    IconButton,
    Button,
    Grid,
    Divider,
    Tab,
    Tabs,
    Paper,
    Tooltip,
    InputAdornment,
    Switch,
    FormControlLabel,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Avatar,
    Chip,
    Alert
} from '@mui/material';
import {
    Add as AddIcon,
    DeleteOutlined as DeleteIcon,
    InventoryOutlined as InventoryIcon,
    CollectionsOutlined as CollectionsIcon,
    Check,
    PhotoCamera,
    LocalOfferOutlined as LocalOfferIcon,
    StorefrontOutlined as StorefrontIcon,
    TuneOutlined as TuneIcon,
    HelpOutline as HelpIcon,
    SwapHoriz as SwapIcon
} from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

// Formatadores e utilitários
const formatBRL = (value) => {
    if (value === undefined || value === null || isNaN(value)) return "0,00";
    return Number(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

const parseBRL = (value) => {
    if (!value) return 0;
    const cleanValue = String(value).replace(/\D/g, "");
    return parseFloat(cleanValue) / 100;
};

// Garante número inteiro estrito não-negativo
const parseInteger = (value, fallback = 0) => {
    const parsed = parseInt(value, 10);
    if (isNaN(parsed) || parsed < 0) return fallback;
    return Math.floor(parsed);
};

// Componente Isolado da Linha de Variação (Moda, Pizzas, Adicionais, etc.)
class VariationItemRow extends PureComponent {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
        this.state = {
            name: props.item.name || '',
            price_adjustment: props.item.price_adjustment || 0,
            price_input: formatBRL(props.item.price_adjustment || 0),
            quanty: parseInteger(props.item.quanty, 0),
            min_quantity: parseInteger(props.item.min_quantity, 0),
            max_quantity: parseInteger(props.item.max_quantity, 10),
            image_url: props.item.image_url || ''
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item !== this.props.item) {
            this.setState({
                name: this.props.item.name || '',
                price_adjustment: this.props.item.price_adjustment || 0,
                price_input: formatBRL(this.props.item.price_adjustment || 0),
                quanty: parseInteger(this.props.item.quanty, 0),
                min_quantity: parseInteger(this.props.item.min_quantity, 0),
                max_quantity: parseInteger(this.props.item.max_quantity, 10),
                image_url: this.props.item.image_url || ''
            });
        }
    }

    handleBlur = (field, value) => {
        this.props.onChange(field, value);
    };

    handleImageSelect = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);
        this.setState({ image_url: previewUrl });
        this.props.onChange('image_file', file);
        this.props.onChange('image_url', previewUrl);
    };

    render() {
        const { gIndex, iIndex, onRemove } = this.props;
        const { name, price_input, quanty, min_quantity, max_quantity, image_url } = this.state;

        return (
            <Paper elevation={0} sx={{ p: 2, mb: 1.5, bgcolor: '#ffffff', borderRadius: 2.5, border: '1px solid #e2e8f0' }}>
                <input
                    type="file"
                    accept="image/*"
                    hidden
                    ref={this.fileInputRef}
                    onChange={this.handleImageSelect}
                />
                <Grid container spacing={2} alignItems="center">
                    {/* Foto da Variação */}
                    <Grid item xs={12} sm="auto">
                        <Tooltip title="Selecione a foto desta variação (Ex: Cor específica)">
                            <Box
                                onClick={() => this.fileInputRef.current?.click()}
                                sx={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: 2,
                                    border: '2px dashed #cbd5e1',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    bgcolor: '#f8fafc',
                                    position: 'relative',
                                    '&:hover': { borderColor: '#7c3aed', bgcolor: '#f1f5f9' }
                                }}
                            >
                                {image_url ? (
                                    <Box
                                        component="img"
                                        src={image_url}
                                        alt={name || "Variação"}
                                        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <PhotoCamera sx={{ color: '#94a3b8', fontSize: 22 }} />
                                )}
                            </Box>
                        </Tooltip>
                    </Grid>

                    {/* Nome da Variação */}
                    <Grid item xs={12} sm={3}>
                        <TextField
                            fullWidth
                            label="Nome da Variação / Opção"
                            size="small"
                            placeholder="Ex: Verde P, Calabresa, Com Catupiry"
                            value={name}
                            onChange={(e) => this.setState({ name: e.target.value })}
                            onBlur={() => this.handleBlur('name', name)}
                        />
                    </Grid>

                    {/* Preço / Adicional */}
                    <Grid item xs={6} sm={2}>
                        <TextField
                            fullWidth
                            label="Preço / Adicional"
                            size="small"
                            value={price_input}
                            onChange={(e) => {
                                const numeric = parseBRL(e.target.value);
                                this.setState({
                                    price_adjustment: numeric,
                                    price_input: formatBRL(numeric)
                                });
                            }}
                            onBlur={() => this.handleBlur('price_adjustment', this.state.price_adjustment)}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                            }}
                        />
                    </Grid>

                    {/* Estoque (Número Inteiro) */}
                    <Grid item xs={6} sm={2}>
                        <TextField
                            fullWidth
                            label="Estoque (Unid.)"
                            size="small"
                            type="number"
                            value={quanty}
                            onChange={(e) => this.setState({ quanty: parseInteger(e.target.value, 0) })}
                            onBlur={() => this.handleBlur('quanty', this.state.quanty)}
                            inputProps={{ min: 0, step: 1 }}
                        />
                    </Grid>

                    {/* Limite Mínimo que o Cliente Pode Escolher */}
                    <Grid item xs={5} sm={2}>
                        <Tooltip title="Quantidade MÍNIMA que 1 cliente pode escolher deste item no pedido">
                            <TextField
                                fullWidth
                                label="Mín. p/ Cliente"
                                size="small"
                                type="number"
                                value={min_quantity}
                                onChange={(e) => this.setState({ min_quantity: parseInteger(e.target.value, 0) })}
                                onBlur={() => this.handleBlur('min_quantity', this.state.min_quantity)}
                                inputProps={{ min: 0, step: 1 }}
                            />
                        </Tooltip>
                    </Grid>

                    {/* Limite Máximo que o Cliente Pode Escolher */}
                    <Grid item xs={5} sm={2}>
                        <Tooltip title="Quantidade MÁXIMA que 1 cliente pode escolher deste item (Ex: até 5 peças 'Verde P')">
                            <TextField
                                fullWidth
                                label="Máx. p/ Cliente"
                                size="small"
                                type="number"
                                value={max_quantity}
                                onChange={(e) => this.setState({ max_quantity: parseInteger(e.target.value, 1) })}
                                onBlur={() => this.handleBlur('max_quantity', this.state.max_quantity)}
                                inputProps={{ min: 1, step: 1 }}
                            />
                        </Tooltip>
                    </Grid>

                    {/* Remover */}
                    <Grid item xs={2} sm="auto" sx={{ textAlign: 'right' }}>
                        <IconButton size="small" color="error" onClick={() => onRemove(gIndex, iIndex)}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

// Card do Grupo de Variações
class GroupCard extends PureComponent {
    render() {
        const {
            grupo,
            gIndex,
            onGrupoChange,
            onRemoverGrupo,
            onItemChange,
            onAdicionarItem,
            onRemoverItem
        } = this.props;

        return (
            <Card sx={{ mb: 3, borderRadius: 3, border: '1px solid #e2e8f0', boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)' }}>
                <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LayersIcon sx={{ color: '#7c3aed' }} />
                            <Typography variant="subtitle1" fontWeight="700" color="#1e293b">
                                Grupo #{gIndex + 1}: {grupo.name || 'Nova Categoria de Variação'}
                            </Typography>
                        </Box>
                        <Tooltip title="Excluir este grupo inteiro">
                            <IconButton size="small" color="error" onClick={() => onRemoverGrupo(gIndex)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        {/* Nome do Grupo */}
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Ex: Tamanho & Cor, Escolha o Sabor, Adicionais"
                                label="Nome do Grupo"
                                value={grupo.name}
                                onChange={(e) => onGrupoChange(gIndex, 'name', e.target.value)}
                            />
                        </Grid>

                        {/* Regra de Cálculo de Preço do Grupo (Essencial para Pizzarias / Moda / Combos) */}
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Regra de Cobrança / Cálculo</InputLabel>
                                <Select
                                    value={grupo.pricing_strategy || 'ADDITIVE'}
                                    label="Regra de Cobrança / Cálculo"
                                    onChange={(e) => onGrupoChange(gIndex, 'pricing_strategy', e.target.value)}
                                >
                                    <MenuItem value="ADDITIVE">➕ Soma dos Adicionais / Valor Fixo (Moda / Padrão)</MenuItem>
                                    <MenuItem value="HIGHEST">🍕 Cobrar Preço da Mais Cara (Pizzas Meio-a-Meio)</MenuItem>
                                    <MenuItem value="AVERAGE">📊 Média dos Preços Selecionados</MenuItem>
                                    <MenuItem value="LOWEST">📉 Cobrar Preço da Mais Barata</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Mínimo de Opções que o Cliente Deve Selecionar no Grupo */}
                        <Grid item xs={6} sm={2}>
                            <TextField
                                fullWidth
                                label="Mín. Opções do Grupo"
                                size="small"
                                type="number"
                                value={grupo.min_selection}
                                onChange={(e) => onGrupoChange(gIndex, 'min_selection', parseInteger(e.target.value, 0))}
                                inputProps={{ min: 0, step: 1 }}
                            />
                        </Grid>

                        {/* Máximo de Opções que o Cliente Pode Selecionar no Grupo */}
                        <Grid item xs={6} sm={2}>
                            <TextField
                                fullWidth
                                label="Máx. Opções do Grupo"
                                size="small"
                                type="number"
                                value={grupo.max_selection}
                                onChange={(e) => onGrupoChange(gIndex, 'max_selection', parseInteger(e.target.value, 1))}
                                inputProps={{ min: 1, step: 1 }}
                            />
                        </Grid>
                    </Grid>

                    {/* Dica de Utilização Dinâmica */}
                    {grupo.pricing_strategy === 'HIGHEST' && (
                        <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
                            <b>Modo Pizzaria Ativo:</b> Quando o cliente escolher 2 ou mais sabores neste grupo, o sistema cobrará o valor do sabor mais caro.
                        </Alert>
                    )}

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle2" fontWeight="700" sx={{ mb: 1.5, color: '#475569' }}>
                        Opções e Estoques de Variação
                    </Typography>

                    {grupo.items.map((item, iIndex) => (
                        <VariationItemRow
                            key={item.id || `item-${gIndex}-${iIndex}`}
                            item={item}
                            gIndex={gIndex}
                            iIndex={iIndex}
                            onChange={(field, val) => onItemChange(gIndex, iIndex, field, val)}
                            onRemove={onRemoverItem}
                        />
                    ))}

                    <Button
                        startIcon={<AddIcon />}
                        size="small"
                        onClick={() => onAdicionarItem(gIndex)}
                        sx={{ mt: 1, textTransform: 'none', color: '#7c3aed', fontWeight: 600 }}
                    >
                        Adicionar Opção / Variação
                    </Button>
                </CardContent>
            </Card>
        );
    }
}

class EditProductsAttributes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            has_variations: false,
            // Preço e Estoque do Produto Simples
            price: 0,
            price_input: "0,00",
            promotional_price: 0,
            promotional_price_input: "0,00",
            cost_price: 0,
            cost_price_input: "0,00",
            stock: 0,
            sku: '',

            // Atacado
            wholesale_enabled: false,
            wholesale_min_qty: 6,
            wholesale_price: 0,
            wholesale_price_input: "0,00",

            // Variações
            variacoes: [],

            isSaving: false,
            hasChanges: false
        };
    }

    componentDidMount() {
        document.title = 'Preços, Estoque e Variações do Produto';
        this.carregarDadosProduto();
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleBeforeUnload = (event) => {
        if (this.state.hasChanges) {
            event.preventDefault();
            event.returnValue = '';
        }
    };

    handleNavigate = (event, to) => {
        if (this.state.hasChanges) {
            const confirmLeave = window.confirm(
                'Você possui alterações não salvas. Se sair agora, as alterações serão perdidas. Deseja continuar?'
            );
            if (!confirmLeave) {
                event.preventDefault();
            }
        }
    };

    carregarDadosProduto = async () => {
        try {
            const response = await fetch(`${apiUrl}/products/variations/${this.props.params.uuid}`, {
                method: "GET",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });

            if (response.status === 200) {
                const data = await response.json();
                this.setState({
                    has_variations: Boolean(data.has_variations),
                    price: data.price || 0,
                    price_input: formatBRL(data.price || 0),
                    promotional_price: data.promotional_price || 0,
                    promotional_price_input: formatBRL(data.promotional_price || 0),
                    cost_price: data.cost_price || 0,
                    cost_price_input: formatBRL(data.cost_price || 0),
                    stock: parseInteger(data.stock, 0),
                    sku: data.sku || '',
                    wholesale_enabled: Boolean(data.wholesale_enabled),
                    wholesale_min_qty: parseInteger(data.wholesale_min_qty, 6),
                    wholesale_price: data.wholesale_price || 0,
                    wholesale_price_input: formatBRL(data.wholesale_price || 0),
                    variacoes: data.variacoes || [],
                    hasChanges: false
                });
            } else {
                toast.error("Erro ao carregar dados do produto.");
            }
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            toast.error("Erro de conexão ao carregar dados do produto.");
        }
    };

    // Alterna se o produto é simples ou tem variação
    handleToggleVariations = (checked) => {
        this.setState({
            has_variations: checked,
            hasChanges: true
        });
    };

    // Adiciona Grupo de Variação
    handleAdicionarGrupo = () => {
        this.setState((prevState) => ({
            variacoes: [
                ...prevState.variacoes,
                {
                    name: '',
                    pricing_strategy: 'ADDITIVE',
                    min_selection: 0,
                    max_selection: 1,
                    items: [
                        { name: '', price_adjustment: 0, quanty: 0, min_quantity: 0, max_quantity: 10, image_url: '' }
                    ]
                }
            ],
            hasChanges: true
        }));
    };

    handleRemoverGrupo = (groupIndex) => {
        this.setState((prevState) => ({
            variacoes: prevState.variacoes.filter((_, index) => index !== groupIndex),
            hasChanges: true
        }));
    };

    handleGrupoChange = (groupIndex, field, value) => {
        this.setState((prevState) => {
            const novasVariacoes = [...prevState.variacoes];
            novasVariacoes[groupIndex] = {
                ...novasVariacoes[groupIndex],
                [field]: value
            };
            return { variacoes: novasVariacoes, hasChanges: true };
        });
    };

    handleAdicionarItem = (groupIndex) => {
        this.setState((prevState) => {
            const novasVariacoes = [...prevState.variacoes];
            const items = [
                ...novasVariacoes[groupIndex].items,
                { name: '', price_adjustment: 0, quanty: 0, min_quantity: 0, max_quantity: 10, image_url: '' }
            ];
            novasVariacoes[groupIndex] = { ...novasVariacoes[groupIndex], items };
            return { variacoes: novasVariacoes, hasChanges: true };
        });
    };

    handleRemoverItem = (groupIndex, itemIndex) => {
        this.setState((prevState) => {
            const novasVariacoes = [...prevState.variacoes];
            const items = novasVariacoes[groupIndex].items.filter((_, index) => index !== itemIndex);
            novasVariacoes[groupIndex] = { ...novasVariacoes[groupIndex], items };
            return { variacoes: novasVariacoes, hasChanges: true };
        });
    };

    handleItemChange = (groupIndex, itemIndex, field, value) => {
        this.setState((prevState) => {
            const novasVariacoes = [...prevState.variacoes];
            const group = { ...novasVariacoes[groupIndex] };
            const items = [...group.items];
            items[itemIndex] = { ...items[itemIndex], [field]: value };
            group.items = items;
            novasVariacoes[groupIndex] = group;
            return { variacoes: novasVariacoes, hasChanges: true };
        });
    };

    handleSalvar = async () => {
        const toastId = toast.loading("Salvando configurações do produto...");
        this.setState({ isSaving: true });

        try {
            const payload = {
                uuid: this.props.params.uuid,
                has_variations: this.state.has_variations,
                price: this.state.price,
                promotional_price: this.state.promotional_price,
                cost_price: this.state.cost_price,
                stock: parseInteger(this.state.stock, 0),
                sku: this.state.sku,
                wholesale_enabled: this.state.wholesale_enabled,
                wholesale_min_qty: parseInteger(this.state.wholesale_min_qty, 0),
                wholesale_price: this.state.wholesale_price,
                variacoes: this.state.variacoes
            };

            const response = await fetch(`${apiUrl}/products/set/pricing-and-variations`, {
                method: "PUT",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.success) {
                toast.update(toastId, {
                    render: "Configurações e estoques salvos com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000
                });
                this.setState({ hasChanges: false }, () => {
                    this.carregarDadosProduto();
                });
            } else {
                throw new Error(data.error || "Erro ao salvar alterações.");
            }
        } catch (error) {
            console.error("Erro ao salvar:", error);
            toast.update(toastId, {
                render: error.message || "Falha ao salvar produto.",
                type: "error",
                isLoading: false,
                autoClose: 3000
            });
        } finally {
            this.setState({ isSaving: false });
        }
    };

    render() {
        const {
            has_variations,
            price_input,
            promotional_price_input,
            cost_price_input,
            stock,
            sku,
            wholesale_enabled,
            wholesale_min_qty,
            wholesale_price_input,
            variacoes,
            isSaving,
            hasChanges
        } = this.state;

        const uuid = this.props.params.uuid;

        return (
            <Box sx={{ p: 0, backgroundColor: '#f8f9fa', minHeight: '100vh', pb: 6 }}>
                {/* Topbar */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
                    <Box>
                        <Typography variant="h5" fontWeight="700" gutterBottom color="#0f172a">
                            Gerenciar Preços, Estoque & Variações
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Configure preços base, vendas no atacado, estoque e grades de variação (Moda, Pizzas, Lanches)
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={this.handleSalvar}
                        disabled={isSaving}
                        startIcon={<Check />}
                        sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            bgcolor: hasChanges ? '#7c3aed' : '#0284c7',
                            '&:hover': { bgcolor: hasChanges ? '#6d28d9' : '#0369a1' }
                        }}
                    >
                        {hasChanges ? "Salvar Alterações *" : "Salvo"}
                    </Button>
                </Box>

                {/* Navegação por Abas com Verificação de Alterações */}
                <Box sx={{ mb: 4 }}>
                    <Tabs
                        value={3}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{
                            '& .MuiTabs-indicator': { display: 'none' },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: '40px',
                                borderRadius: '8px',
                                mr: 1,
                                fontWeight: 500,
                                color: '#64748b',
                                whiteSpace: 'nowrap'
                            },
                            '& .Mui-selected': {
                                bgcolor: '#fff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                color: '#0f172a !important',
                                fontWeight: 700
                            }
                        }}
                    >
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/basic`}
                            onClick={(e) => this.handleNavigate(e, `/produtos/${uuid}/basic`)}
                            icon={<InventoryIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Informações Básicas"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/photos`}
                            onClick={(e) => this.handleNavigate(e, `/produtos/${uuid}/photos`)}
                            icon={<CollectionsIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Fotos do Produto"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/price`}
                            onClick={(e) => this.handleNavigate(e, `/produtos/${uuid}/price`)}
                            icon={<AttachMoneyIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Preço & Promoções"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/attributes`}
                            icon={<LayersIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Preço, Estoque & Variações"
                        />
                    </Tabs>
                </Box>

                {/* Chave de Seleção: Produto Simples vs Produto Com Variações */}
                <Paper elevation={0} sx={{ p: 3, mb: 4, borderRadius: 3, border: '1px solid #e2e8f0', bgcolor: '#fff' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar sx={{ bgcolor: has_variations ? '#f3e8ff' : '#e0f2fe', color: has_variations ? '#7c3aed' : '#0284c7' }}>
                                {has_variations ? <TuneIcon /> : <StorefrontIcon />}
                            </Avatar>
                            <Box>
                                <Typography variant="h6" fontWeight="700">
                                    {has_variations ? "Produto com Variações / Opções" : "Produto Simples"}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {has_variations
                                        ? "Este produto possui opções de tamanho, cor, sabores ou adicionais. O preço final e estoque são calculados por variação."
                                        : "Este produto possui preço único e estoque centralizado."}
                                </Typography>
                            </Box>
                        </Box>

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={has_variations}
                                    onChange={(e) => this.handleToggleVariations(e.target.checked)}
                                    color="secondary"
                                />
                            }
                            label={
                                <Typography fontWeight="600" color="#334155">
                                    Ativar Variações / Grade
                                </Typography>
                            }
                        />
                    </Box>
                </Paper>

                {/* BLOCO 1: PRODUTO SIMPLES (Caso não tenha variações) */}
                {!has_variations && (
                    <>
                        <Card sx={{ mb: 4, borderRadius: 3, border: '1px solid #e2e8f0', boxShadow: '0px 2px 8px rgba(0,0,0,0.04)' }}>
                            <CardContent sx={{ p: 3 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                                    <AttachMoneyIcon sx={{ color: '#0284c7' }} />
                                    <Typography variant="subtitle1" fontWeight="700">
                                        Preço e Estoque Principal
                                    </Typography>
                                </Box>

                                <Grid container spacing={2.5}>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            label="Preço Normal"
                                            size="small"
                                            value={price_input}
                                            onChange={(e) => {
                                                const numeric = parseBRL(e.target.value);
                                                this.setState({
                                                    price: numeric,
                                                    price_input: formatBRL(numeric),
                                                    hasChanges: true
                                                });
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            label="Preço Promocional"
                                            size="small"
                                            value={promotional_price_input}
                                            onChange={(e) => {
                                                const numeric = parseBRL(e.target.value);
                                                this.setState({
                                                    promotional_price: numeric,
                                                    promotional_price_input: formatBRL(numeric),
                                                    hasChanges: true
                                                });
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            label="Preço de Custo"
                                            size="small"
                                            value={cost_price_input}
                                            onChange={(e) => {
                                                const numeric = parseBRL(e.target.value);
                                                this.setState({
                                                    cost_price: numeric,
                                                    cost_price_input: formatBRL(numeric),
                                                    hasChanges: true
                                                });
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                            }}
                                        />
                                    </Grid>

                                    {/* Estoque Número Inteiro */}
                                    <Grid item xs={6} sm={1.5}>
                                        <TextField
                                            fullWidth
                                            label="Estoque (Unid.)"
                                            size="small"
                                            type="number"
                                            value={stock}
                                            onChange={(e) => this.setState({
                                                stock: parseInteger(e.target.value, 0),
                                                hasChanges: true
                                            })}
                                            inputProps={{ min: 0, step: 1 }}
                                        />
                                    </Grid>

                                    <Grid item xs={6} sm={1.5}>
                                        <TextField
                                            fullWidth
                                            label="Código / SKU"
                                            size="small"
                                            value={sku}
                                            onChange={(e) => this.setState({ sku: e.target.value, hasChanges: true })}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* Módulo de Atacado */}
                        <Card sx={{ mb: 4, borderRadius: 3, border: '1px solid #e2e8f0', boxShadow: '0px 2px 8px rgba(0,0,0,0.04)' }}>
                            <CardContent sx={{ p: 3 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <LocalOfferIcon sx={{ color: '#059669' }} />
                                        <Typography variant="subtitle1" fontWeight="700">
                                            Venda em Atacado
                                        </Typography>
                                    </Box>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={wholesale_enabled}
                                                onChange={(e) => this.setState({ wholesale_enabled: e.target.checked, hasChanges: true })}
                                                color="success"
                                            />
                                        }
                                        label="Ativar Preço de Atacado"
                                    />
                                </Box>

                                {wholesale_enabled && (
                                    <Grid container spacing={2.5} sx={{ mt: 1 }}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Quantidade Mínima para Atacado"
                                                size="small"
                                                type="number"
                                                value={wholesale_min_qty}
                                                onChange={(e) => this.setState({
                                                    wholesale_min_qty: parseInteger(e.target.value, 1),
                                                    hasChanges: true
                                                })}
                                                inputProps={{ min: 1, step: 1 }}
                                                helperText="Exemplo: a partir de 6 unidades o preço unitário diminui"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                fullWidth
                                                label="Preço Unitário de Atacado"
                                                size="small"
                                                value={wholesale_price_input}
                                                onChange={(e) => {
                                                    const numeric = parseBRL(e.target.value);
                                                    this.setState({
                                                        wholesale_price: numeric,
                                                        wholesale_price_input: formatBRL(numeric),
                                                        hasChanges: true
                                                    });
                                                }}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                                }}
                                                helperText="Preço cobrado por unidade quando atingir a quantidade mínima"
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            </CardContent>
                        </Card>
                    </>
                )}

                {/* BLOCO 2: PRODUTO COM VARIAÇÕES (Moda, Pizzas, Sabores, Tamanhos) */}
                {has_variations && (
                    <Box>
                        {variacoes.map((grupo, gIndex) => (
                            <GroupCard
                                key={grupo.id || `grupo-${gIndex}`}
                                grupo={grupo}
                                gIndex={gIndex}
                                onGrupoChange={this.handleGrupoChange}
                                onRemoverGrupo={this.handleRemoverGrupo}
                                onItemChange={this.handleItemChange}
                                onAdicionarItem={this.handleAdicionarItem}
                                onRemoverItem={this.handleRemoverItem}
                            />
                        ))}

                        <Box sx={{ mb: 4 }}>
                            <Button
                                fullWidth
                                variant="outlined"
                                startIcon={<AddIcon />}
                                onClick={this.handleAdicionarGrupo}
                                sx={{
                                    p: 2,
                                    borderRadius: 3,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    color: '#7c3aed',
                                    borderColor: '#cbd5e1',
                                    '&:hover': { borderColor: '#7c3aed', bgcolor: '#f8f5ff' }
                                }}
                            >
                                Criar Novo Grupo de Variação / Categoria de Opções
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
        );
    }
}

export default WithRouter(EditProductsAttributes);